import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Route, Redirect } from "react-router-dom"
import API from "store/api"
import { getUser } from "actions/user"
import { loginSuccess } from "actions/authentication"
import { useHistory } from "react-router-dom"

// protected route component
const ProtectedRoute = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const stateToken = useSelector(state => state.authentication.token)
  const urlParams = new URLSearchParams(window.location.search)
  const queryToken = urlParams.get("token")
  const userId = urlParams.get("user")

  useEffect(() => {
    if (queryToken && queryToken.length > 0) {
      API.set("Authorization", queryToken)
      dispatch(getUser(userId, queryToken)).then(res => {
        dispatch(loginSuccess(res, queryToken))
        history.push(window.location.pathname)
      })
    }
  }, [])

  // destructures passed in component
  const { component: C, ...routeProps } = props
  // token from redux that was stored on login
  const token = queryToken && queryToken.length > 0 ? queryToken : stateToken
  return (
    <Route
      render={p =>
        token ? (
          // if there is a token that is stored we render the component
          <C {...p} {...routeProps} />
        ) : (
          // if there is not a token that is stored we redirect to /login
          <div>
            <Redirect
              to={{
                pathname: props.queryString ? "/register" : "/login",
                search: props.queryString
              }}
            />
          </div>
        )
      }
    />
  )
}

export default ProtectedRoute



// WEBPACK FOOTER //
// ./src/components/ProtectedRoute/index.js